import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, catchError, of } from 'rxjs';
import { BotResourceService } from '../services/bot-resource.service';

export const botOwnerGuard: CanActivateFn = () => {
  const botService = inject(BotResourceService);
  const router = inject(Router);
  return botService.getSession().pipe(
    map((session) => {
      if (session?.is_website_bot_owner) {
        return true;
      }
      router.navigate(['/templates']);
      return false;
    }),
    catchError(() => {
      router.navigate(['/templates']);
      return of(false);
    })
  );
};
